<template lang="pug">
  #super-reporting
    WtTitle(h2)
      span.pr-2 Super Admin Reports

    EveryStepReport()
    ActiveProgramsReport()
    ProgramVsProgramReport()
</template>

<script>
import ActiveProgramsReport from "@/views/ActiveProgramsReport.vue";
import EveryStepReport from "@@/SuperAdminReports/EveryStepReport.vue";
import ProgramVsProgramReport from "@@/SuperAdminReports/ProgramVsProgramReport.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";

export default {
  name: "AdminSuperReporting",
  components: {
    ActiveProgramsReport,
    EveryStepReport,
    ProgramVsProgramReport,
    WtTitle
  }
};
</script>
